import { Linkable } from "@/components/elements/Linkable";
import { LoginForm } from "@/features/auth/components/LoginForm";
import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { AppRoutes } from "@/routes/config";
import { background, divider, text } from "@/theme/colors";
import { rounded } from "@/theme/variables";
import { Box, Stack, Typography } from "@mui/material";
import { FC } from "react";

type TLoginPageProps = {};

export const LoginPage: FC<TLoginPageProps> = () => {
  return (
    <Stack gap={6} alignItems="center">
      <LoginLogo />
      <LoginForm />
      <Linkable href={AppRoutes.recover}>
        <Typography variant="sub16Semi" color="#1890FF">
          パスワードを忘れた方はこちら
        </Typography>
      </Linkable>

      <Stack width={400} borderRadius={rounded.sm} border={`1px solid ${divider.high}`} overflow="hidden">
        <Typography
          component="p"
          color={text.secondary}
          sx={{ backgroundColor: background.secondary }}
          py={1}
          textAlign="center"
          variant="body14Bold"
        >
          動作環境
        </Typography>
        <Box
          component="ul"
          borderTop={`1px solid ${divider.high}`}
          py={1}
          margin={0}
          pl={3}
          pr={2}
          sx={{
            "& li::marker": {
              fontSize: "0.5rem",
            },
          }}
        >
          <Typography component="li" variant="body14" color={text.secondary}>
            Google Chrome または Microsoft Edge 最新版 <br />
            <Typography variant="cap12" color={text.secondary}>
              （製造元のサポートが終了しているOSやWebブラウザー等は動作環境の対象外となります。）
            </Typography>
          </Typography>
          <Typography component="li" variant="body14" color={text.secondary}>
            ノートPC（1366 x 768px）以上のディスプレイ解像度 <br />
            <Typography variant="cap12" color={text.secondary}>
              （スマートフォン、タブレットは動作対象外）
            </Typography>
          </Typography>
        </Box>
      </Stack>
    </Stack>
  );
};
